export default __webpack_public_path__ + "static/media/Rotate.73068289.png";